import React, { useState, useRef, useEffect } from 'react';
import { trackEvent } from '../../../helpers/mixpanel';
import SchedulingModal from '../../../components/modals/SchedulingModal';

const GetStartedButton = ({ id, className = "btn-secondary  btn-4xl ", label = "Get Started" }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const timeoutRef = useRef(null);

    const handleClick = () => {
        trackEvent(id);
        setModalOpen(true);
    };

    useEffect(() => {
       setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, []);


    return (
        <>
            <button
                onClick={handleClick}
                className={className}
            >
                {label}
            </button>
            {!isLoading && <SchedulingModal open={modalOpen} setOpen={setModalOpen} />}
        </>
    )
}

export default GetStartedButton